import React from "../_snowpack/pkg/react.js";
import {formatNumber, formatRupiah} from "../services/Formatters.js";
import {useTranslation} from "../_snowpack/pkg/react-i18next.js";
import "./ROIBreakdown.css";
import {Table} from "../_snowpack/pkg/antd.js";
export const ROIBreakdown = (props) => {
  const {t, i18n} = useTranslation();
  const columns = [
    {
      title: t("roiTable.year"),
      dataIndex: "index"
    },
    {
      title: t("roiTable.output"),
      dataIndex: "output",
      render: (output) => `${formatNumber(output, i18n.language)} kWh`
    },
    {
      title: t("roiTable.tariff"),
      dataIndex: "tariff",
      render: (tariff) => formatRupiah(tariff)
    },
    {
      title: t("roiTable.profit"),
      dataIndex: "cumulativeProfit",
      render: (cumulativeProfit) => formatRupiah(cumulativeProfit)
    }
  ];
  return /* @__PURE__ */ React.createElement(Table, {
    dataSource: props.yearly,
    columns,
    className: "roiBreakdown",
    pagination: false,
    rowKey: (res) => res.index
  }, /* @__PURE__ */ React.createElement(Table.Summary, {
    fixed: true
  }));
};
